'use client';

import { useEffect } from 'react';
import { useGameStore } from '@/store/useGameStore';

export function StreakInitializer() {
  const updateStreak = useGameStore((s) => s.updateStreak);

  useEffect(() => {
    updateStreak();
  }, [updateStreak]);

  return null;
}
